import { Box, Typography, Card, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import globalStyles from "../../../global";
import { getResponsiveSize } from "../../../utils/responsive";

import News from "../../../components/globalCountries/countryhomepagescomponent/News";
import FreeDeliveryBannerSr from "../components/Freedeliverysr";
import FooterSr from "../components/Footersr"

const containerWidth = "1200px";

const BlogSr = () => {
  const { t } = useTranslation();
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  const styles = {
    heroSection: {
      // display: "flex",
      // flexDirection: { xs: "column", md: isRTL ? "row-reverse" : "row" },
      bgcolor: "#e0e7d8",
    },
    container: {
      display: "flex",
      flexDirection: {
        xs: "column",
        md: "row",
      },
      gap: "30px",
      // gridTemplateColumns: {
      //   md: 'repeat(2, auto)',
      // },
      justifyContent: "center",
      alignItems: "center",
      maxWidth: containerWidth,
      mx: "auto",
      height: "100%", // <-- Add this
    },

    heroImage: {
      mt: 1,
      width: "50%",
      height: "50%",
      maxHeight: "500px",
      objectFit: "cover", // Fills the container without gap
      display: "block", // Removes default inline spacing
    },
    heroTextBox: {
      minWidth: { lg: "600px" },
      p: 4,
    },
    heroTitleContainer: {
      textAlign: "center",
      fontWeight: "bold",
      px: 4,
      py: 4,
      ml: { xs: 0, md: "-100px" },
      mr: 0,
    },
    heroTitle: {
      fontSize: {
        md: "55px",
        sm: "36px",
        xs: "30px",
      },
      color: globalStyles.colors.army_green,
      fontFamily: globalStyles.fonts.primaryUAE,
      letterSpacing: "1%",
      lineHeight: "60px",
      fontWeight: 400,
    },
    greenText: {
      color: globalStyles.colors.uclean_green,
      display: "inline",
      fontFamily: globalStyles.fonts.primaryUAE,
    },
    heroSubtitle: {
      mt: { xs: 2, md: 4 },
      color: globalStyles.colors.uclean_green,
      fontSize: "inherit",
    },
    sectionTitle: {
      textAlign: "center",
      fontFamily: globalStyles.fonts.primaryUAE,
      fontWeight: 600,
      px: 4,
      mt: 8,
      fontSize: getResponsiveSize(40),
      color: globalStyles.colors.army_green,
      textTransform: "uppercase",
    },
    sectionSubtitle: {
      textAlign: "center",
      fontFamily: globalStyles.fonts.primary,
      px: 4,
      fontSize: getResponsiveSize(18),
      color: globalStyles.colors.light_gray,
      fontWeight: 400,
      mt: "1%",
    },
    divider: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      mt: { xs: 8, md: 16 },
      mb: { xs: 8, md: 16 },
      bgcolor: globalStyles.colors.army_green,
      height: getResponsiveSize(200),
    },
  };

  return (
    <Box sx={styles.mainContainer}>
      {/* Hero Section */}
      <Box sx={styles.heroSection}>
        <Box sx={styles.container}>
          <Box
            component="img"
            src={`${imageBaseUrl}countryServices.png`}
            alt={t("blog.heroTitle.part1")}
            sx={{
              ...styles.heroImage,
              verticalAlign: "bottom",
              display: {
                xs: "none",
                sm: "none",
                md: "block",
              },
            }}
          />
          <Box sx={styles.heroTextBox}>
            <Typography variant="h1" sx={styles.heroTitle}>
              {t("blog.heroTitle.part1") + " " + t("blog.heroTitle.part2")}
            </Typography>
            {/* <Typography variant="h1" sx={styles.heroTitle}>
              {t("blog.heroTitle.part2")}
            </Typography> */}
          </Box>
        </Box>
      </Box>

      {/* ✅ Cards Section (OUTSIDE heroTextBox now) */}
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          px: {
            xs: 1,
            sm: 2,
          },
          display: "flex",
          gap: "21px",
          justifyContent: "end",
          pt: 8,
        }}
      >
        <Box
          component="select"
          className="sm:w-[200px] w-full px-3 py-2 border border-gray-300 rounded-md text-sm font-poppins"
        >
          {["Sort By", "By Date", "By Name", "By Views"].map((e) => (
            <option key={e} value={e}>
              {e}
            </option>
          ))}
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          maxWidth: "1200px",
          mx: "auto",
          display: "flex",
          flexWrap: "wrap",
          gap: "21px",
          justifyContent: "center",
          pt: 4,
          pb: 8,
          px: {
            xs: 1,
            sm: 0,
          },
        }}
      >
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
          <Card
            key={item}
            sx={{
              width: {
                xs: "100%",
                sm: "48%",
                lg: "31.5%",
              },
              height: "auto",
              boxShadow: "1.04px 1.04px 26.01px 0px #0000000D",
              borderRadius: "15px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#fff",
              transition: "all 0.3s ease",
              border: "1px solid transparent",
              "&:hover": {
                boxShadow: "1px 1px 25px 0px #0000001A",
                // border: "1px solid #174C2E",
                backgroundColor: "#F0FFF5",
              },
            }}
          >
            {/* IMAGE with no gap */}
            <Box
              component="img"
              src={`${imageBaseUrl}blogCardImage.png`}
              alt="Card Image"
              sx={{
                width: "100%",
                height: "300px",
                objectFit: "cover",
                display: "block",
              }}
            />

            {/* Content box with padding */}
            <Box
              sx={{
                p: 3,
                display: "flex",
                flexDirection: "column",
                gap: "18.73px",
                flexGrow: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: { md: "30px", sm: "24px", xs: "20px" },
                  fontWeight: 600,
                  fontFamily: "'Poppins'",
                  color: "#174C2E",
                  lineHeight: "31.22px",
                  letterSpacing: "0%",
                }}
              >
                Laundromat chain UClean plans to open over 75 outlets in MENA...
              </Typography>

              <Typography
                sx={{
                  fontSize: { sm: "12px", xs: "9px" },
                  opacity: 0.75,
                  fontFamily: "'Poppins'",
                  fontWeight: 400,
                  lineHeight: "100%",
                  letterSpacing: "0%",
                  color: "#4d4d4d",
                }}
              >
                Date Posted: February 16, 2024
              </Typography>

              <Typography
                sx={{
                  fontSize: { sm: "18px", xs: "14px" },
                  color: "#4d4d4d",
                  fontFamily: "'Poppins'",
                  textAlign: "justify",
                  letterSpacing: "0%",
                  lineHeight: "150%",
                  fontWeight: 400,
                }}
              >
                Founded in 2016, UClean is franchise driven brand that uses its
                network to provide quality services, focusing on hygiene and
                sustainability through its innovative channels.
              </Typography>

              <Button
                variant="contained"
                sx={{
                  width: "186px",
                  height: "45px",
                  gap: "10px",
                  borderRadius: "10px",
                  pt: "15px",
                  pr: "10px",
                  pb: "15px",
                  pl: "10px",
                  backgroundColor: "#FFFFFF",
                  color: "#65BA0D",
                  textTransform: "none",
                  fontWeight: 600,
                 fontSize: { sm: "18px", xs: "14px" },
                  border: "1px solid #65BA0D",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#c3e3b9",
                    boxShadow: "none",
                  },
                }}
              >
                Read More
              </Button>
            </Box>
          </Card>
        ))}
      </Box>

      {/* Promo/Banner/News */}
      <FreeDeliveryBannerSr />
      <News />
    
      <FooterSr />
    </Box>
  );
};

export default BlogSr;

